import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxUploaderModule } from 'ngx-uploader';
import { RouterModule } from '@angular/router';
import {
  MatButtonModule,
  MatGridListModule,
  MatListModule,
  MatCardModule,
  MatProgressSpinnerModule,
  MatTableModule,
  MatFormFieldModule,
  MatInputModule,
  MatDividerModule,
  MatProgressBarModule
} from '@angular/material';

import { SitesService } from '../services/sites.service';
import { ProductsService } from '../services/products.service';
import { SiteListComponent } from './components/site-list/site-list.component';
import { SiteEditorComponent } from './components/site-editor/site-editor.component';
import { SiteViewComponent } from './components/site-view/site-view.component';
import { ComponentsModule } from '../components/components.module';
import { ExistingSiteEditorComponent } from './components/existing-site-editor/existing-site-editor.component';

@NgModule({
  declarations: [
    SiteListComponent,
    SiteEditorComponent,
    SiteViewComponent,
    ExistingSiteEditorComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    MatButtonModule,
    MatDividerModule,
    MatGridListModule,
    MatListModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    NgxUploaderModule,
    FormsModule
  ],
  providers: [
    SitesService,
    ProductsService
  ]
})

export class SitesModule {}